<button type="button" class="rse-toggle" [attr.aria-expanded]="open()" aria-controls="rse-panel" (click)="onToggle()">
  <mat-icon aria-hidden="true">settings</mat-icon>
  {{ 'requirements.statuses.manage' | translate }}
</button>

@if (open()) {
  <div id="rse-panel" class="rse-panel" role="region">
    <div class="rse-panel__heading">{{ 'requirements.statuses.editorTitle' | translate }}</div>
    <div class="rse-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
      @for (entry of entries(); track entry.clientId; let i = $index) {
        <div class="rse-row" [class.rse-row--new]="entry.isNew" cdkDrag [cdkDragDisabled]="disabled()">
          <button
            type="button"
            class="rse-row__handle"
            cdkDragHandle
            [disabled]="disabled()"
            [attr.aria-label]="'requirements.statuses.reorder.ariaLabel' | translate: { name: entry.value }"
            (keydown)="onHandleKeydown(i, $event)"
          >
            <mat-icon aria-hidden="true">drag_indicator</mat-icon>
          </button>
          <input
            type="text"
            class="rse-row__input"
            [attr.aria-label]="'requirements.statuses.valueAria' | translate: { name: entry.value }"
            [value]="entry.value"
            [disabled]="disabled()"
            (input)="onRename(i, $any($event.target).value)"
          />
          <button
            type="button"
            class="rse-row__delete"
            [disabled]="disabled() || !canDeleteMore()"
            [attr.aria-label]="'requirements.statuses.deleteAria' | translate: { name: entry.value }"
            (click)="onDelete(i)"
          >
            <mat-icon aria-hidden="true">delete</mat-icon>
          </button>
        </div>
      }
    </div>

    <div class="rse-add">
      <input
        type="text"
        class="rse-add__input"
        [attr.placeholder]="'requirements.statuses.newPlaceholder' | translate"
        [attr.aria-label]="'requirements.statuses.newPlaceholder' | translate"
        [value]="newValue()"
        [disabled]="disabled()"
        (input)="onNewValueInput($event)"
        (keydown)="onNewValueKeydown($event)"
      />
      <button
        type="button"
        class="rse-add__btn"
        [disabled]="disabled() || newValue().trim().length === 0"
        (click)="onAdd()"
      >
        <mat-icon aria-hidden="true">add</mat-icon>
        {{ 'requirements.statuses.addButton' | translate }}
      </button>
    </div>
  </div>
}
